import { render, staticRenderFns } from "./BreastSymptomsPart.vue?vue&type=template&id=38ccee55&scoped=true&"
import script from "./BreastSymptomsPart.ts?vue&type=script&lang=ts&"
export * from "./BreastSymptomsPart.ts?vue&type=script&lang=ts&"
import style0 from "./BreastSymptomsPart.scss?vue&type=style&index=0&id=38ccee55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ccee55",
  null
  
)

export default component.exports